//@flow

import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledSelect = styled.select`
  width: inherit;
  min-width: inherit;
  margin: 0 0 2px 0;
  border: solid;
  border-width: 2px;
  border-color: ${props => props.invalid ? '#e47d7d' : '#e1e1e1'};
  border-radius: 4px;
  color: #333333;
  font-weight: 500;
  font-family: "Open Sans",sans-serif;
  line-height: 16px;
  padding: 4px;
  :focus{
    border-color: #7dafe4;
    background-color: #ffffff;
    outline-style:none;
  }
  :disabled {
    background-color: #f1f1f1;
  }
  :-webkit-autofill {
    -webkit-box-shadow: 0 0 0 100px white inset;
  }
`;

const Tip = styled.p`
  width: inherit;
  text-align: center;
  color: ${props => props.invalid ? '#932d28' : '#265a9c'};
  display: ${props => props.invalid || props.focus ? 'block' : 'none'};
  font-size: 12px;
  margin: 0 0 5px 0;
`;

export default class SelectInput extends React.Component<Props, State> {
  constructor() {
    super();
    this.state = {
      focus: false,
    }
  }

  render() {
    return (
      <Wrapper
        style={this.props.style}>
        <StyledSelect {...this.props}
          innerRef={(node) => { this.domNode = node }}
          style={{}}
          tabIndex="0"
          onFocus={() => {
            if (typeof this.props.onFocus === 'function')
              this.props.onFocus();
            this.setState({ focus: true })
          }}
          onBlur={() => {
            if (typeof this.props.onBlur === 'function')
              this.props.onBlur();
            this.setState({ focus: false })
          }}
        >
          {this.props.children}
        </StyledSelect>
        {this.props.tip
          ? <Tip
            {...this.props}
            focus={this.state.focus}
          >
            {this.props.tip}
          </Tip>
          : ''
        }
      </Wrapper>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SelectInput.jsx